import React from 'react'

export default class Alert extends React.Component {
  render() {
    return (
      <div className={`alert mt-3 mb-0 ${this.props.alertType}`} role="alert">
        <span>{this.props.alertMessage}</span>
      </div>
    )
  }
}
